export const USER_INIT = "user_init"
export const USER_REGISTER = "user_register"
export const USER_LOGIN = "user_login"
export const USER_WALLETS = "user_wallets"
export const SOCKET_UPDATEWALLET = "SOCKET_updateWallet"
